import React from "react";
import "./ResultGameCard.css";
import { getBoxScore, getLogo } from "../../util";

const LOGO_SIZE = 128;

const getWinner = (
  homeScore: number,
  awayScore: number,
  home: string,
  away: string
) => {
  if (homeScore > awayScore) {
    return home;
  } else if (homeScore < awayScore) {
    return away;
  }
  return "TIE";
};

const getMargin = (homeScore: number, awayScore: number) =>
  Math.abs(homeScore - awayScore);

const Card = ({
  home,
  away,
  homeScore,
  awayScore,
  pointsEarned,
  predictedMargin,
  predictedWinner,
  pointsBreakdown,
}: {
  home: string;
  away: string;
  homeScore: number;
  awayScore: number;
  pointsEarned: number;
  predictedMargin: string;
  predictedWinner: string;
  pointsBreakdown: string;
}) => {
  const cssPoints = pointsEarned === 0 ? "Result-loss" : "Result-win";
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const boxScoreLink = getBoxScore(yesterday, home);

  return (
    <>
      <div className="ResultGameCard-container">
        <div className="ResultGameCard-matchup">
          <img src={getLogo(away, LOGO_SIZE)} />
          <div className="ResultGameCard-score ResultGameCard-matchupItem">
            {awayScore}
          </div>
          <div className="finalandbox">
            <h3 className="ResultGameCard-matchupItem finalText">Final</h3>
            <a href={boxScoreLink} target="_blank">
              Box Score
            </a>
          </div>
          <div className="ResultGameCard-score ResultGameCard-matchupItem">
            {homeScore}
          </div>
          <img src={getLogo(home, LOGO_SIZE)} />
        </div>
        <div className="ResultGameCard-outcomeContainer">
          <div className="ResultGameCard-resultItem">
            <div className="ResultGameCard-pointBreakdown">
              Your Prediction:
            </div>
            <div className="ResultGameCard-result">
              {predictedWinner} by {predictedMargin}
            </div>
          </div>
          <div className="ResultGameCard-resultItem">
            <div className="ResultGameCard-pointBreakdown"> Actual Result:</div>
            <div className="ResultGameCard-result">
              {getWinner(homeScore, awayScore, home, away)} by{" "}
              {getMargin(homeScore, awayScore)}
            </div>
          </div>
          <div className="ResultGameCard-resultItem">
            <div className="ResultGameCard-pointBreakdown"> Points Earned:</div>
            <div className={cssPoints}>{pointsEarned}</div>
          </div>
          <div className="ResultGameCard-pointBreakdown">{pointsBreakdown}</div>
        </div>
      </div>
    </>
  );
};

export default Card;
